<section class="listviewSection">
  <ng-container> </ng-container>
  <ng-container>
    <mat-list>
      <mat-card>
        <section class="sections">
          <div class="filterSection">
            <div class="wrapper">
              <div class="wrapperImage">
              </div>
            </div>
            <div class="contentWrapper">
              <div class="innerContent">
                <div class="contentSection">
                  <div class="headingSection">
                    <div class="starRating">
                    </div>
                    <div class="typeSection"></div>
                  </div>
                  <div class="nameSection"><h3></h3>
                  </div>
                  <a class="location"><p></p></a>
                  <div class="amenitiesSection">
                    <ul><li></li><li></li><li></li><li></li><li></li></ul>
                  </div>
                </div>
                <div class="ratingSection"></div>
                <!--------------------- ###Hardcore design ------------------------>
              </div>
            </div>
          </div>
          <mat-divider [vertical]="true"></mat-divider>
          <div class="dealSection">
            <div class="wrapper">
              <div class="amenities">
                <button mat-button>Amenities</button>
              </div>
              <div class="dealAmount">
                <div class="deals"></div>
                <div class="credits"></div>
                <div class="amountSection">
                  <div class="amount"><span></span></div>
                  <div class="value"><p></p></div>
                </div>
              </div>
            </div>
            <div class="bookingBtn">
              <button mat-button></button>
            </div>
          </div>
        </section>
      </mat-card>
    </mat-list><mat-list>
      <mat-card>
        <section class="sections">
          <div class="filterSection">
            <div class="wrapper">
              <div class="wrapperImage">
              </div>
            </div>
            <div class="contentWrapper">
              <div class="innerContent">
                <div class="contentSection">
                  <div class="headingSection">
                    <div class="starRating">
                    </div>
                    <div class="typeSection"></div>
                  </div>
                  <div class="nameSection"><h3></h3>
                  </div>
                  <a class="location"><p></p></a>
                  <div class="amenitiesSection">
                    <ul><li></li><li></li><li></li><li></li><li></li></ul>
                  </div>
                </div>
                <div class="ratingSection"></div>
                <!--------------------- ###Hardcore design ------------------------>
              </div>
            </div>
          </div>
          <mat-divider [vertical]="true"></mat-divider>
          <div class="dealSection">
            <div class="wrapper">
              <div class="amenities">
                <button mat-button>Amenities</button>
              </div>
              <div class="dealAmount">
                <div class="deals"></div>
                <div class="credits"></div>
                <div class="amountSection">
                  <div class="amount"><span></span></div>
                  <div class="value"><p></p></div>
                </div>
              </div>
            </div>
            <div class="bookingBtn">
              <button mat-button></button>
            </div>
          </div>
        </section>
      </mat-card>
    </mat-list><mat-list>
      <mat-card>
        <section class="sections">
          <div class="filterSection">
            <div class="wrapper">
              <div class="wrapperImage">
              </div>
            </div>
            <div class="contentWrapper">
              <div class="innerContent">
                <div class="contentSection">
                  <div class="headingSection">
                    <div class="starRating">
                    </div>
                    <div class="typeSection"></div>
                  </div>
                  <div class="nameSection"><h3></h3>
                  </div>
                  <a class="location"><p></p></a>
                  <div class="amenitiesSection">
                    <ul><li></li><li></li><li></li><li></li><li></li></ul>
                  </div>
                </div>
                <div class="ratingSection"></div>
                <!--------------------- ###Hardcore design ------------------------>
              </div>
            </div>
          </div>
          <mat-divider [vertical]="true"></mat-divider>
          <div class="dealSection">
            <div class="wrapper">
              <div class="amenities">
                <button mat-button>Amenities</button>
              </div>
              <div class="dealAmount">
                <div class="deals"></div>
                <div class="credits"></div>
                <div class="amountSection">
                  <div class="amount"><span></span></div>
                  <div class="value"><p></p></div>
                </div>
              </div>
            </div>
            <div class="bookingBtn">
              <button mat-button></button>
            </div>
          </div>
        </section>
      </mat-card>
    </mat-list><mat-list>
      <mat-card>
        <section class="sections">
          <div class="filterSection">
            <div class="wrapper">
              <div class="wrapperImage">
              </div>
            </div>
            <div class="contentWrapper">
              <div class="innerContent">
                <div class="contentSection">
                  <div class="headingSection">
                    <div class="starRating">
                    </div>
                    <div class="typeSection"></div>
                  </div>
                  <div class="nameSection"><h3></h3>
                  </div>
                  <a class="location"><p></p></a>
                  <div class="amenitiesSection">
                    <ul><li></li><li></li><li></li><li></li><li></li></ul>
                  </div>
                </div>
                <div class="ratingSection"></div>
                <!--------------------- ###Hardcore design ------------------------>
              </div>
            </div>
          </div>
          <mat-divider [vertical]="true"></mat-divider>
          <div class="dealSection">
            <div class="wrapper">
              <div class="amenities">
                <button mat-button>Amenities</button>
              </div>
              <div class="dealAmount">
                <div class="deals"></div>
                <div class="credits"></div>
                <div class="amountSection">
                  <div class="amount"><span></span></div>
                  <div class="value"><p></p></div>
                </div>
              </div>
            </div>
            <div class="bookingBtn">
              <button mat-button></button>
            </div>
          </div>
        </section>
      </mat-card>
    </mat-list>
  </ng-container>
</section>
